import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { InputSwitch } from "primereact/inputswitch";
import { Loading } from "../../componentes/loading/loading";
import ConfiguracaoSolicitacaoService from "../../services/resource/configuracaoSolicitacaoService";
import { formatarDataHora } from "../../utils/solicitacoes/formatters";

const service = new ConfiguracaoSolicitacaoService();

// Aba "Configuração": regras do módulo que podem ser ligadas/desligadas (ver ChaveConfiguracao no backend).
// Cada alteração vale na hora, para todos os usuários.
export default function ConfiguracaoGeralTab() {
    const [configs, setConfigs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [salvandoChave, setSalvandoChave] = useState(null);

    useEffect(() => {
        service.listar()
            .then(res => setConfigs(res.data || []))
            .catch(() => toast.error("Erro ao carregar as configurações."))
            .finally(() => setLoading(false));
    }, []);

    function alternar(config, ativo) {
        setSalvandoChave(config.chave);
        service.alterar(config.chave, ativo)
            .then(res => {
                setConfigs(prev => prev.map(c => (c.chave === config.chave ? res.data : c)));
                toast.success(`${config.titulo}: ${ativo ? "ativado" : "desativado"}.`);
            })
            .catch(e => toast.error(e?.response?.data?.message || "Não foi possível salvar a configuração."))
            .finally(() => setSalvandoChave(null));
    }

    if (loading) return <Loading />;

    const grupos = [...new Set(configs.map(c => c.grupo))];

    return (
        <div className="flex flex-col gap-4">
            {configs.length === 0 && <p className="text-sm text-muted-foreground">Nenhuma configuração disponível.</p>}
            {grupos.map(grupo => (
                <div key={grupo} className="bg-card border border-border rounded-lg shadow-card p-4 flex flex-col gap-3">
                    <h3 className="text-sm font-semibold text-foreground">{grupo}</h3>
                    {configs.filter(c => c.grupo === grupo).map(config => (
                        <div key={config.chave} className="flex items-start justify-between gap-4 border-t border-border pt-3 first-of-type:border-t-0 first-of-type:pt-0">
                            <div className="min-w-0">
                                <span className="block text-sm font-medium text-foreground">{config.titulo}</span>
                                <span className="block text-xs text-muted-foreground mt-0.5">{config.descricao}</span>
                                <span className="block text-[11px] text-muted-foreground mt-1">
                                    {config.dataAlteracao
                                        ? `Alterado por ${config.usuarioAlteracao || "-"} em ${formatarDataHora(config.dataAlteracao)}`
                                        : `Padrão do sistema (${config.padrao ? "ativado" : "desativado"})`}
                                </span>
                            </div>
                            <div className="flex items-center gap-2 shrink-0">
                                <span className={`text-xs font-semibold ${config.ativo ? "text-success" : "text-muted-foreground"}`}>
                                    {config.ativo ? "Ativado" : "Desativado"}
                                </span>
                                <InputSwitch checked={config.ativo} disabled={salvandoChave === config.chave}
                                    onChange={e => alternar(config, e.value)} />
                            </div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
